var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "newQianniuExam" } }, [
    _c("div", { staticClass: "el-tabs el-tabs--left" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs__content" }, [
        _c(
          "div",
          { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: { src: "/tjkStudy/static/newqianniu/qnbg.jpg" }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon01",
                        attrs: {
                          src: "/tjkStudy/static/newqianniu/qnicon01.png"
                        },
                        on: { click: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: { src: "/tjkStudy/static/newqianniu/qnbg.jpg" }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02",
                        attrs: {
                          src: "/tjkStudy/static/newqianniu/qnicon02.png"
                        },
                        on: { dblclick: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginImg,
                          expression: "isShowLoginImg"
                        }
                      ],
                      staticClass: "login"
                    },
                    [
                      _c("img", {
                        staticClass: "homeImg",
                        attrs: { src: "/tjkStudy/static/newqianniu/login.jpg" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text", placeholder: "请输入账号" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.password,
                            expression: "password",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "password",
                        attrs: {
                          type: "password",
                          autocomplete: "new-password",
                          placeholder: "请输入密码"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logIn",
                        on: { click: _vm.loginIn }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowRnd,
                          expression: "isShowRnd"
                        }
                      ],
                      staticClass: "loginrnd"
                    },
                    [
                      _c("img", {
                        staticClass: "rndImg",
                        attrs: {
                          src: "/tjkStudy/static/newqianniu/loginrnd.jpg"
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.rnd,
                            expression: "rnd",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "rnd",
                        attrs: {
                          type: "text",
                          placeholder: "请输入短信验证码"
                        },
                        domProps: { value: _vm.rnd },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.rnd = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logInRnd",
                        on: { click: _vm.loginInRnd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndex,
                          expression: "isShowLoginIndex"
                        }
                      ],
                      staticClass: "jdbox"
                    },
                    [
                      _c("img", {
                        staticClass: "jdimg",
                        attrs: { src: "/tjkStudy/static/newqianniu/jdicon.jpg" }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "jdicon",
                        on: { click: _vm.enterJd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndexTwo,
                          expression: "isShowLoginIndexTwo"
                        }
                      ],
                      staticClass: "indexbox"
                    },
                    [
                      _c("img", {
                        staticClass: "indeximg",
                        attrs: { src: "/tjkStudy/static/newqianniu/gq.jpg" }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请点击"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("左侧练习场")]
                          ),
                          _vm._v("中的千牛图标进行登录")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginImg
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取账号密码。本次模拟练习，请点击下方按钮获取账号密码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showPassword = true
                                }
                              }
                            },
                            [_vm._v("获取账号密码")]
                          ),
                          _vm._v(" "),
                          _vm.showPassword
                            ? [
                                _vm._m(2),
                                _vm._v(" "),
                                _vm._m(3),
                                _vm._v(" "),
                                _c("p", [_vm._v("密码：")]),
                                _vm._v(" "),
                                _vm._m(4)
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowRnd
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取短信验证码。本次模拟练习，请点击下方按钮获取短信验证码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showRnd = true
                                }
                              }
                            },
                            [_vm._v("获取短信验证码")]
                          ),
                          _vm._v(" "),
                          _vm.showRnd
                            ? [
                                _c("p", [_vm._v("短信验证码：")]),
                                _vm._v(" "),
                                _vm._m(5)
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginIndex
                      ? _c("p", [_vm._v("请进入千牛接待中心")])
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second", 2, "second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "second" },
            attrs: { id: "tab-second-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isShowWgq,
                          expression: "!isShowWgq"
                        }
                      ],
                      staticClass: "gqbox"
                    },
                    [
                      _c("img", {
                        staticClass: "gqimg",
                        attrs: { src: "/tjkStudy/static/newqianniu/gq.jpg" }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "gqbtn",
                        on: {
                          click: function($event) {
                            _vm.showGqImg = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "qhimg",
                        attrs: { src: "/tjkStudy/static/newqianniu/qh.png" }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "gqclick",
                        on: { click: _vm.showWgqImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "wgqbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowWgq,
                          expression: "isShowWgq"
                        }
                      ],
                      staticClass: "wgqimg",
                      attrs: { src: "/tjkStudy/static/newqianniu/wgq.jpg" }
                    })
                  ])
                ]),
                _vm._v(" "),
                _vm._m(6)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third", 3, "third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "third" },
            attrs: { id: "tab-third-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    { staticClass: "jdgkbox" },
                    [
                      _c("img", {
                        staticClass: "jiedaiimg",
                        attrs: { src: "/tjkStudy/static/newqianniu/jiedai.jpg" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "replyone" }, [
                        _c("p", { staticClass: "session" }, [
                          _c("span", { staticClass: "user" }, [
                            _vm._v("fanchaocdmc")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "time" }, [
                            _vm._v(_vm._s(_vm.time))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(7)
                      ]),
                      _vm._v(" "),
                      _vm.isShowOne
                        ? [
                            _c("el-input", {
                              staticClass: "jiedaitextarea",
                              attrs: { type: "textarea" },
                              nativeOn: {
                                keydown: function($event) {
                                  return _vm.listenOne($event)
                                }
                              },
                              model: {
                                value: _vm.jdnr,
                                callback: function($$v) {
                                  _vm.jdnr =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "jdnr"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "jdbtn",
                              on: { click: _vm.showJieDaiImgOne }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowTwo
                        ? [
                            _c("el-input", {
                              staticClass: "jiedaitextarea",
                              attrs: { type: "textarea" },
                              nativeOn: {
                                keydown: function($event) {
                                  return _vm.listenTwo($event)
                                }
                              },
                              model: {
                                value: _vm.jdnr,
                                callback: function($$v) {
                                  _vm.jdnr =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "jdnr"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "jdbtn",
                              on: { click: _vm.showJieDaiImgTwo }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowThree
                        ? [
                            _c("el-input", {
                              staticClass: "jiedaitextarea",
                              attrs: { type: "textarea" },
                              nativeOn: {
                                keydown: function($event) {
                                  return _vm.listenThree($event)
                                }
                              },
                              model: {
                                value: _vm.jdnr,
                                callback: function($$v) {
                                  _vm.jdnr =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "jdnr"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "jdbtn",
                              on: { click: _vm.showJieDaiImgThree }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowFour
                        ? [
                            _c("el-input", {
                              staticClass: "jiedaitextarea",
                              attrs: { type: "textarea" },
                              nativeOn: {
                                keydown: function($event) {
                                  return _vm.listenFour($event)
                                }
                              },
                              model: {
                                value: _vm.jdnr,
                                callback: function($$v) {
                                  _vm.jdnr =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "jdnr"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "jdbtn",
                              on: { click: _vm.showJieDaiImgFour }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(8),
                  _vm._v(" "),
                  _vm.isShowOne
                    ? _c("p", [
                        _vm._v("请接待顾客，回复内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("您好！欢迎光临，请问有什么可以帮到您？")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTwo
                    ? _c("p", [
                        _vm._v("请接待顾客，回复内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("亲亲，正常情况下大概3天左右能到哦！")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowThree
                    ? _c("p", [
                        _vm._v("请接待顾客，回复内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("请问还有什么可以帮到您？")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowFour
                    ? _c("p", [
                        _vm._v("请接待顾客，回复内容："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("好的，感谢亲亲的支持，祝您生活愉快")]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four", 4, "four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "four" },
            attrs: { id: "tab-four-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zdhfbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon || _vm.isShowZdhf01,
                          expression: "isShowZdhficon || isShowZdhf01"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: { src: "/tjkStudy/static/newqianniu/gq.jpg" }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon,
                          expression: "isShowZdhficon"
                        }
                      ],
                      staticClass: "zdhficon",
                      on: { click: _vm.showZdhf01 }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf01,
                            expression: "isShowZdhf01"
                          }
                        ],
                        staticClass: "zdhf01"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf01.png"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf01icon",
                          on: { click: _vm.showZdhf02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf02,
                            expression: "isShowZdhf02"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf02.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf02icon",
                          on: { click: _vm.showZdhf03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf03,
                            expression: "isShowZdhf03"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf03.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf03icon",
                          on: { click: _vm.showZdhf04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf04,
                            expression: "isShowZdhf04"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf04.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf04icon",
                          on: { click: _vm.showZdhf05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf05,
                            expression: "isShowZdhf05"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf05.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "zdhf05icon",
                          attrs: { type: "textarea", rows: 10 },
                          model: {
                            value: _vm.zdhf,
                            callback: function($$v) {
                              _vm.zdhf =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "zdhf"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf05btn",
                          on: { click: _vm.showZdhf06 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf06,
                            expression: "isShowZdhf06"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf06.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf06icon",
                          on: { click: _vm.showZdhf07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf07,
                            expression: "isShowZdhf07"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf07.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf07icon",
                          on: { click: _vm.showZdhf08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf08,
                            expression: "isShowZdhf08"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf08.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf08icon",
                          on: { click: _vm.showZdhf09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf09,
                            expression: "isShowZdhf09"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf09.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf09icon",
                          on: { click: _vm.showZdhf10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf10,
                            expression: "isShowZdhf10"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zdhf10.jpg"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(9)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five", 5, "five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "five" },
            attrs: { id: "tab-five-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cjxxbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxxicon,
                            expression: "isShowCjxxicon"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          staticClass: "gqimg",
                          attrs: { src: "/tjkStudy/static/newqianniu/gq.jpg" }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxxicon",
                          on: { click: _vm.showCjxx01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx01,
                            expression: "isShowCjxx01"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx01.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx01icon",
                          on: { click: _vm.showCjxx02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx02,
                            expression: "isShowCjxx02"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx02.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx02icon",
                          on: { click: _vm.showCjxx03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx03,
                            expression: "isShowCjxx03"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx03.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx03icon",
                          on: { click: _vm.showCjxx04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx04,
                            expression: "isShowCjxx04"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx04.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx04icon",
                          on: { mouseover: _vm.showCjxx05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx05,
                            expression: "isShowCjxx05"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx05.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx05icon",
                          on: { click: _vm.showCjxx06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx06,
                            expression: "isShowCjxx06"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx06.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx06icon",
                          on: { mouseover: _vm.showCjxx07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx07,
                            expression: "isShowCjxx07"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx07.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx07icon",
                          on: { click: _vm.showCjxx08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx08,
                            expression: "isShowCjxx08"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx08.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx08icon",
                          on: { mouseover: _vm.showCjxx09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx09,
                            expression: "isShowCjxx09"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx09.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx09icon",
                          on: { click: _vm.showCjxx10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx10,
                            expression: "isShowCjxx10"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx10.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx10icon",
                          on: { mouseover: _vm.showCjxx11 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx11,
                            expression: "isShowCjxx11"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx11.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx11icon",
                          on: { click: _vm.showCjxx12 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx12,
                            expression: "isShowCjxx12"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx12.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx12icon",
                          on: { mouseover: _vm.showCjxx13 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx13,
                            expression: "isShowCjxx13"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx13.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx13icon",
                          on: { click: _vm.showCjxx14 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx14,
                            expression: "isShowCjxx14"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx14.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx14icon",
                          on: { mouseover: _vm.showCjxx15 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx15,
                            expression: "isShowCjxx15"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx15.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx15icon",
                          on: { click: _vm.showCjxx16 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx16,
                            expression: "isShowCjxx16"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx16.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx16icon",
                          on: { mouseover: _vm.showCjxx17 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx17,
                            expression: "isShowCjxx17"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx17.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx17icon",
                          on: { click: _vm.showCjxx18 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx18,
                            expression: "isShowCjxx18"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx18.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx18icon",
                          on: { mouseover: _vm.showCjxx19 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx19,
                            expression: "isShowCjxx19"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx19.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjxx19icon",
                          on: { click: _vm.showCjxx20 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjxx20,
                            expression: "isShowCjxx20"
                          }
                        ],
                        staticClass: "cjxx"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/cjxx20.jpg"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(10),
                    _vm._v(" "),
                    _vm.isShowCjxxTip
                      ? _c("p", [_vm._v("请调出一位最近联系人的对话")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowCjxxTip01 ||
                    _vm.isShowCjxxTip02 ||
                    _vm.isShowCjxxTip03 ||
                    _vm.isShowCjxxTip04
                      ? [
                          _c("p", [_vm._v("请依次完成以下操作：")]),
                          _vm._v(" "),
                          _vm._m(11),
                          _vm._v(" "),
                          _vm._m(12),
                          _vm._v(" "),
                          _vm._m(13),
                          _vm._v(" "),
                          _vm._m(14)
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowCjxxTip05
                      ? _c("p", [_vm._v("请关闭旺旺插件中心")])
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six", 6, "six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six" },
            attrs: { id: "tab-six-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "kjdybox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdyicon,
                            expression: "isShowKjdyicon"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: { src: "/tjkStudy/static/newqianniu/kjdy.jpg" }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdyicon",
                          on: { click: _vm.showKjdy01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy01,
                            expression: "isShowKjdy01"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/kjdy01.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy01icon",
                          on: { mouseover: _vm.showKjdy02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy02,
                            expression: "isShowKjdy02"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/kjdy02.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy02icon",
                          on: { click: _vm.showKjdy03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy03,
                            expression: "isShowKjdy03"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/kjdy03.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdy03input",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy04.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy03icon",
                          on: { click: _vm.showKjdy04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy04,
                            expression: "isShowKjdy04"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/kjdy04.jpg"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isShowKjdy05
                      ? _c(
                          "div",
                          { staticClass: "kjdy" },
                          [
                            _c("img", {
                              attrs: {
                                src: "/tjkStudy/static/newqianniu/kjdy01.jpg"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "kjdytextarea",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.kjdy,
                                callback: function($$v) {
                                  _vm.kjdy =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "kjdy"
                              }
                            }),
                            _vm._v(" "),
                            _vm.isShowKjdy06
                              ? _c("img", {
                                  staticClass: "kjdy05icon",
                                  attrs: {
                                    src:
                                      "/tjkStudy/static/newqianniu/kjdy08.png"
                                  },
                                  on: { click: _vm.showKjdy05 }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowKjdy07
                      ? _c("div", { staticClass: "kjdy" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/kjdy03.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "focus",
                                rawName: "v-focus",
                                value: true,
                                expression: "true"
                              }
                            ],
                            staticClass: "kjdy03input",
                            attrs: { type: "text" },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.showKjdy06.apply(null, arguments)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "kjdy03icon",
                            on: { click: _vm.showKjdy06 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowKjdy08
                      ? _c("div", { staticClass: "kjdy" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/kjdy04.jpg"
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowKjdy09
                      ? _c("div", { staticClass: "kjdy" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/kjdy04.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "kjdy04icon",
                            on: { click: _vm.showKjdy07 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowKjdy10
                      ? _c("div", { staticClass: "kjdy" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/kjdy05.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "kjdy06icon" }, [
                            _c("input", {
                              staticClass: "btn-file",
                              attrs: { type: "file" },
                              on: {
                                change: function($event) {
                                  return _vm.tirggerFile($event)
                                }
                              }
                            })
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowKjdy11
                      ? _c("div", { staticClass: "kjdy" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/kjdy06.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "kjdy07icon",
                            on: { click: _vm.showKjdy08 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowKjdy12
                      ? _c("div", { staticClass: "kjdy" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/kjdy07.jpg"
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(15),
                  _vm._v(" "),
                  _vm.isShowKjdyTip01
                    ? _c("p", [
                        _vm._v(
                          "使用快捷短语操作练习：请采用鼠标左键点击快捷键的方式，给当前顾客发送一条结束语的快捷短语"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip02
                    ? _c("div", [
                        _c("p", [_vm._v("使用快捷短语操作练习：")]),
                        _vm._v(" "),
                        _vm._m(16)
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip03
                    ? _c("div", [
                        _c("p", [_vm._v("导入快捷短语操作练习：")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("请先下载下方的快捷短语表格，并保存在桌面上")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                            _vm._v("点击下载“快捷短语.csv”")
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip04
                    ? _c("div", [
                        _c("p", [_vm._v("导入快捷短语操作练习：")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("请将下载好的快捷短语表格导入到千牛上")
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven", 7, "seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "seven" },
            attrs: { id: "tab-seven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "ztsbbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZtsbicon,
                            expression: "isShowZtsbicon"
                          }
                        ],
                        staticClass: "ztsb"
                      },
                      [
                        _c("img", {
                          attrs: { src: "/tjkStudy/static/newqianniu/ztsb.jpg" }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "ztsbicon",
                          on: { mouseover: _vm.showZtsb01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZtsb01,
                            expression: "isShowZtsb01"
                          }
                        ],
                        staticClass: "ztsb"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/ztsb01.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "ztsb01icon",
                          on: { click: _vm.showZtsb02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZtsb02,
                            expression: "isShowZtsb02"
                          }
                        ],
                        staticClass: "ztsb"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/ztsb02.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "ztsb02icon",
                          on: { mouseover: _vm.showZtsb03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZtsb03,
                            expression: "isShowZtsb03"
                          }
                        ],
                        staticClass: "ztsb"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/ztsb03.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "ztsb03icon",
                          on: { click: _vm.showZtsb04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZtsb04,
                            expression: "isShowZtsb04"
                          }
                        ],
                        staticClass: "ztsb"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/ztsb04.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "ztsb04icon",
                          on: { mouseover: _vm.showZtsb05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZtsb05,
                            expression: "isShowZtsb05"
                          }
                        ],
                        staticClass: "ztsb"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/ztsb05.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "ztsb05icon",
                          on: { click: _vm.showZtsb06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZtsb06,
                            expression: "isShowZtsb06"
                          }
                        ],
                        staticClass: "ztsb"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/ztsb06.jpg"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(17),
                  _vm._v(" "),
                  _vm.isShowZtsbTip01
                    ? _c("p", [
                        _vm._v("状态识别：请将对话切换为“"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("已下单，未付款")]
                        ),
                        _vm._v("”的顾客")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowZtsbTip02
                    ? _c("p", [
                        _vm._v("状态识别：请将对话切换为“"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("已付款，未发货")]
                        ),
                        _vm._v("”的顾客")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowZtsbTip03
                    ? _c("p", [
                        _vm._v("状态识别：请将对话切换为“"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("已发货，未收货")]
                        ),
                        _vm._v("”的顾客")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eight", 8, "eight")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "eight" },
            attrs: { id: "tab-eight-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgnicon,
                            expression: "isShowZjgnicon"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: { src: "/tjkStudy/static/newqianniu/zjgn.jpg" }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgnicon",
                          on: { click: _vm.showZjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn01,
                            expression: "isShowZjgn01"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zjgn01.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn01icon",
                          on: { mouseover: _vm.showZjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn03,
                            expression: "isShowZjgn03"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zjgn03.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn03icon",
                          on: { mouseover: _vm.showZjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn04,
                            expression: "isShowZjgn04"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zjgn04.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn04icon",
                          on: { click: _vm.showZjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn05,
                            expression: "isShowZjgn05"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/zjgn05.jpg"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(18)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-nine", 9, "nine")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "nine" },
            attrs: { id: "tab-nine-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-nine" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-nine" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "tjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTjgnicon,
                            expression: "isShowTjgnicon"
                          }
                        ],
                        staticClass: "tjgn"
                      },
                      [
                        _c("img", {
                          attrs: { src: "/tjkStudy/static/newqianniu/tjgn.jpg" }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tjgnicon",
                          on: { mouseover: _vm.showTjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTjgn01,
                            expression: "isShowTjgn01"
                          }
                        ],
                        staticClass: "tjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tjgn01.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tjgn01icon",
                          on: { click: _vm.showTjgn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTjgn02,
                            expression: "isShowTjgn02"
                          }
                        ],
                        staticClass: "tjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tjgn02.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tjgn02icon",
                          on: { click: _vm.showTjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTjgn03,
                            expression: "isShowTjgn03"
                          }
                        ],
                        staticClass: "tjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tjgn03.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tjgn03icon",
                          on: { mouseover: _vm.showTjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTjgn04,
                            expression: "isShowTjgn04"
                          }
                        ],
                        staticClass: "tjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tjgn04.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tjgn04icon",
                          on: { click: _vm.showTjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTjgn05,
                            expression: "isShowTjgn05"
                          }
                        ],
                        staticClass: "tjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tjgn05.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "tjgn05input",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showTjgn06.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tjgn05icon",
                          on: { click: _vm.showTjgn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTjgn06,
                            expression: "isShowTjgn06"
                          }
                        ],
                        staticClass: "tjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tjgn06.jpg"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(19)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-nine" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-ten", 10, "ten")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "ten" },
            attrs: { id: "tab-ten-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-ten" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-ten" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "ddcjbox" }, [
                    _vm.isShowDdcj07
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj07.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "ddcj07icon",
                            on: { mouseover: _vm.showDdcj08 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj08
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj08.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "ddcj08icon",
                            on: { click: _vm.showDdcj09 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj09
                      ? _c(
                          "div",
                          { staticClass: "ddcj" },
                          [
                            _c("img", {
                              attrs: {
                                src: "/tjkStudy/static/newqianniu/ddcj09.jpg"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "ddcj09input",
                              attrs: { placeholder: "" },
                              model: {
                                value: _vm.ddcjyf,
                                callback: function($$v) {
                                  _vm.ddcjyf =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "ddcjyf"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "ddcj09icon",
                              on: { click: _vm.showDdcj10 }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcjicon
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "ddcjicon",
                            on: { click: _vm.showDdcj01 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj01
                      ? _c(
                          "div",
                          { staticClass: "ddcj" },
                          [
                            _c("img", {
                              attrs: {
                                src: "/tjkStudy/static/newqianniu/ddcj01.jpg"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "ddcj01input",
                              attrs: {
                                type: "textarea",
                                placeholder: "请填写备注"
                              },
                              model: {
                                value: _vm.ddcjbz,
                                callback: function($$v) {
                                  _vm.ddcjbz =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "ddcjbz"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "ddcj01icon",
                              on: { click: _vm.showDdcj02 }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj02
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj02.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "ddcj02icon",
                            on: { click: _vm.showDdcj03 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj03
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj03.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "ddcj03icon",
                            on: { click: _vm.showDdcj04 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj04
                      ? _c(
                          "div",
                          { staticClass: "ddcj" },
                          [
                            _c("img", {
                              attrs: {
                                src: "/tjkStudy/static/newqianniu/ddcj04.jpg"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "ddcj04input",
                              attrs: { placeholder: "请输入地址" },
                              model: {
                                value: _vm.ddcjdz,
                                callback: function($$v) {
                                  _vm.ddcjdz =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "ddcjdz"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "ddcj04icon",
                              on: { click: _vm.showDdcj05 }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj05
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj05.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "ddcj05icon",
                            on: { click: _vm.showDdcj06 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj06
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj06.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "focus",
                                rawName: "v-focus",
                                value: true,
                                expression: "true"
                              }
                            ],
                            staticClass: "ddcj06input",
                            attrs: { type: "text" },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.showDdcj07.apply(null, arguments)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "ddcj06icon",
                            on: { click: _vm.showDdcj07 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowDdcj10
                      ? _c("div", { staticClass: "ddcj" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/ddcj10.jpg"
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(20),
                  _vm._v(" "),
                  _vm.isShowDdcjTip01
                    ? _c("p", [
                        _vm._v("订单插件操作练习：1.请将商品邮费改成"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("10")]
                        ),
                        _vm._v("元")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowDdcjTip02
                    ? _c("p", [
                        _vm._v(
                          "订单插件操作练习：2.请点击备注按钮，给此客户添加备注内容“"
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("顾客要求发顺丰")]
                        ),
                        _vm._v("”")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowDdcjTip03
                    ? _c("p", [
                        _vm._v("订单插件操作练习：3.请将街道地址修改为“"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("双流区大林镇")]
                        ),
                        _vm._v("”并核对地址")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-ten" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eleven", 11, "eleven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "eleven" },
            attrs: { id: "tab-eleven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eleven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eleven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "xjrwbox" }, [
                    _vm.isShowXjrwicon
                      ? _c("div", { staticClass: "xjrw" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/xjrw.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "xjrwicon",
                            on: { click: _vm.showXjrw01 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowXjrw01
                      ? _c("div", { staticClass: "xjrw" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/xjrw01.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "xjrw01icon",
                            on: { click: _vm.showXjrw02 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowXjrw02
                      ? _c(
                          "div",
                          { staticClass: "xjrw" },
                          [
                            _c("img", {
                              attrs: {
                                src: "/tjkStudy/static/newqianniu/xjrw02.jpg"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "xjrw02input",
                              attrs: {
                                type: "textarea",
                                placeholder:
                                  "请输入任务内容，按Ctrl+回车键，创建任务"
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  if (!$event.ctrlKey) {
                                    return null
                                  }
                                  return _vm.showXjrw06.apply(null, arguments)
                                }
                              },
                              model: {
                                value: _vm.xjrwtxt,
                                callback: function($$v) {
                                  _vm.xjrwtxt =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "xjrwtxt"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "xjrw02icon",
                              on: { click: _vm.showXjrw03 }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowXjrw03
                      ? _c("div", { staticClass: "xjrw" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/xjrw03.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "xjrw03icon",
                            on: { click: _vm.showXjrw04 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowXjrw04
                      ? _c("div", { staticClass: "xjrw" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/xjrw04.jpg"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "xjrw04icon",
                            on: { click: _vm.showXjrw05 }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowXjrw05
                      ? _c(
                          "div",
                          { staticClass: "xjrw" },
                          [
                            _c("img", {
                              attrs: {
                                src: "/tjkStudy/static/newqianniu/xjrw05.jpg"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-date-picker", {
                              staticClass: "xjrw05input",
                              attrs: {
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm",
                                format: "yyyy-MM-dd HH:mm",
                                placeholder: "选择日期时间"
                              },
                              model: {
                                value: _vm.xjrwsj,
                                callback: function($$v) {
                                  _vm.xjrwsj = $$v
                                },
                                expression: "xjrwsj"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "xjrw05icon",
                              on: { click: _vm.showXjrw06 }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowXjrw06
                      ? _c("div", { staticClass: "xjrw" }, [
                          _c("img", {
                            attrs: {
                              src: "/tjkStudy/static/newqianniu/xjrw06.jpg"
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(21),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "新建任务操作练习：请给同事“乐乐”新建一个跟进此顾客的任务提醒，任务内容编辑为“"
                    ),
                    _c(
                      "span",
                      { staticStyle: { color: "red", "font-weight": "bold" } },
                      [_vm._v("此顾客有购买意向，请继续跟进")]
                    ),
                    _vm._v("”，提醒时间设置为"),
                    _c(
                      "span",
                      { staticStyle: { color: "red", "font-weight": "bold" } },
                      [_vm._v(_vm._s(_vm.xjrwmt))]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-eleven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-twelve", 12, "twelve")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "twelve" },
            attrs: { id: "tab-twelve-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-twelve" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-twelve" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "tcqnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqnicon,
                            expression: "isShowTcqnicon"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: { src: "/tjkStudy/static/newqianniu/tcqn.jpg" }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqnicon",
                          on: { click: _vm.showTcqn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn01,
                            expression: "isShowTcqn01"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn01.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn01icon",
                          on: { click: _vm.showTcqn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn02,
                            expression: "isShowTcqn02"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn02.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn02icon",
                          on: { click: _vm.showTcqn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn03,
                            expression: "isShowTcqn03"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn03.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn03icon",
                          on: { mouseover: _vm.showTcqn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn04,
                            expression: "isShowTcqn04"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn04.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn04icon",
                          on: { click: _vm.showTcqn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn05,
                            expression: "isShowTcqn05"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn05.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn05icon",
                          on: { mouseover: _vm.showTcqn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn06,
                            expression: "isShowTcqn06"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn06.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn06icon",
                          on: { click: _vm.showTcqn07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn07,
                            expression: "isShowTcqn07"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn07.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn07icon",
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              return _vm.showTcqn08.apply(null, arguments)
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn08,
                            expression: "isShowTcqn08"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn08.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn08icon",
                          on: { click: _vm.showTcqn09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn09,
                            expression: "isShowTcqn09"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn09.jpg"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcqn09icon",
                          on: { click: _vm.showTcqn10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcqn10,
                            expression: "isShowTcqn10"
                          }
                        ],
                        staticClass: "tcqn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/tjkStudy/static/newqianniu/tcqn10.jpg"
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(22),
                  _vm._v(" "),
                  _vm.isShowTcqnTip01
                    ? _c("p", [_vm._v("请先将状态切换为“挂起”")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTcqnTip02
                    ? _c("p", [
                        _vm._v("退出千牛练习：请退出"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("左侧练习场")]
                        ),
                        _vm._v("中的千牛工作台")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-twelve" } },
                  [_vm._m(23)]
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("1、登录千牛工作台")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("2、切换状态")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("3、接待顾客")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("4、设置自动回复")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("5、添加插件")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("6、快捷短语的使用和导入")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("7、状态识别")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-eight" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("8、转接功能")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-nine" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("9、商品插件学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-ten" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("10、订单插件学习")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-eleven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("11、新建任务")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-twelve" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("12、退出千牛")])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("账号（"),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("账号中间的冒号是英文冒号")
      ]),
      _vm._v("）：")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("淘金客服:001")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("TJ2019")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("660220")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("请将状态切换为“"),
        _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
          _vm._v("未挂起")
        ]),
        _vm._v("”状态")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("span", [_vm._v("在吗？")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("请新增一条内容为“"),
        _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
          _vm._v("您好！欢迎光临，请问有什么可以帮到您？")
        ]),
        _vm._v("”的自动回复，并设置成“"),
        _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
          _vm._v("当天第一次收到买家消息时自动回复")
        ]),
        _vm._v("”")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("1、添加"),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("“淘宝商品管理”")
      ]),
      _vm._v("插件")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("2、添加"),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("“淘宝交易管理”")
      ]),
      _vm._v("插件")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("3、添加"),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("“智能客服”")
      ]),
      _vm._v("插件")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("4、添加"),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("“物流”")
      ]),
      _vm._v("插件")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用/+快捷编码的方式（例如："),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("/结束")
      ]),
      _vm._v("），给当前顾客发送一条结束语的快捷短语")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n              提示\n            ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("转接功能操作练习：请将“"),
        _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
          _vm._v("客户001")
        ]),
        _vm._v("”转接给“"),
        _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
          _vm._v("小红（贝拉）")
        ]),
        _vm._v("”")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n              提示\n            ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("商品插件操作练习：请将"),
        _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
          _vm._v("团队推荐")
        ]),
        _vm._v("里，"),
        _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
          _vm._v("销量最高的蓝牙耳机")
        ]),
        _vm._v("链接发送给顾客")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n              提示\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tip" }, [
      _c("span", { staticClass: "el-icon-success" }),
      _vm._v(" "),
      _c("p", [
        _vm._v("你已完成千牛模拟实操，"),
        _c("br"),
        _vm._v("接下来请完成《京麦功能学习》。")
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "startstudy",
          staticStyle: { width: "160px" },
          attrs: { href: "/tjkStudy/simulate/jmStudy" }
        },
        [_vm._v("去完成京麦功能学习")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b2c3cf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b2c3cf6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/simulate/newQianNiuExam_11618.vue
// module id = 1401
// module chunks = 0